import MapsHomeWorkOutlinedIcon from '@mui/icons-material/MapsHomeWorkOutlined'
import {
  Avatar,
  Box,
  Checkbox,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'

import rem from '~/utils/ui'

type TAssistantSelectionItem = {
  id: string
  label: string
  checked: boolean
  disabled?: boolean
  tooltip?: string
  dimmed?: boolean
}

type TProps = {
  items: TAssistantSelectionItem[]
  onToggle: (id: string, checked: boolean) => void
  showSelectAll?: boolean
  allSelected?: boolean
  someSelected?: boolean
  onToggleAll?: (checked: boolean) => void
  disableSelectAll?: boolean
}

export default function AssistantSelectionList({
  items,
  onToggle,
  showSelectAll = false,
  allSelected = false,
  someSelected = false,
  onToggleAll = undefined,
  disableSelectAll = false,
}: TProps) {
  const theme = useTheme()

  return (
    <Stack gap={1}>
      {showSelectAll && onToggleAll && (
        <Box sx={{ pl: rem(4) }}>
          <Stack direction="row">
            <Typography
              component="label"
              sx={{ display: 'inline-flex', alignItems: 'center' }}
            >
              <Checkbox
                checked={allSelected}
                indeterminate={someSelected && !allSelected}
                disabled={disableSelectAll}
                onChange={(event) => onToggleAll(event.target.checked)}
              />
              <Typography variant="body1">Select all</Typography>
            </Typography>
          </Stack>
        </Box>
      )}
      {items.map((item) => (
        <Tooltip key={item.id} title={item.tooltip || ''} placement="bottom">
          <Box component="span" sx={{ display: 'block' }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{
                border: `${rem(1)} solid ${theme.palette.divider}`,
                borderRadius: rem(8),
                px: 1,
                py: 0.5,
                opacity: item.dimmed ? 0.55 : 1,
                cursor: item.disabled ? 'default' : 'pointer',
              }}
              onClick={() => {
                if (!item.disabled) {
                  onToggle(item.id, !item.checked)
                }
              }}
            >
              <Checkbox
                checked={item.checked}
                disabled={item.disabled}
                onClick={(event) => event.stopPropagation()}
                onChange={(event) => onToggle(item.id, event.target.checked)}
              />
              <Avatar
                variant="circular"
                sx={{
                  width: rem(32),
                  height: rem(32),
                  bgcolor: theme.palette.action.selected,
                  color: theme.palette.text.secondary,
                }}
              >
                <MapsHomeWorkOutlinedIcon sx={{ fontSize: rem(18) }} />
              </Avatar>
              <Typography
                variant="body1"
                noWrap
                sx={{
                  flex: 1,
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {item.label}
              </Typography>
            </Stack>
          </Box>
        </Tooltip>
      ))}
    </Stack>
  )
}
